// @ vendors
const moment = require('moment');
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
const Immutable = require('immutable');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

// @helpers
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLanguage } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const {
    recordLink,
    recordProcess,
    PROC_BUY_GDI,
    PROC_FAIL,
    PROC_SIGNATURE_PATTERN,
} = require('utilities/tagging');
const IbanHelper = require('utilities/ibanHelper');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { updateConsents } = require('actions/gdprConsents');

// @ constants
const actionTypes = require('../constants/actionTypes');
const { OKCONSENTS_RESET } = require('gdpr-consents/constants/actionTypes');
const {
    BROKER_ORDER_TYPE_BUY,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    CONNECTION_CHANNEL_INTERNET,
    EURO_TEXT,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    BROKER_CUSTOM_WALLET_PORTFOLIO_ACCOUNT_TYPE,
} = require('constants/index');
const {
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_SECOND_STEP,
    CM_WIZARD_THIRD_STEP,
    CHANGE_AGENT_ID,
    CM_BUY_TYPE_MONEY,
    CM_EUR_CURRENCY,
    CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE,
    CM_HIRE_OPERATION_TYPE,
    CM_OPERATION_TYPE_TRASPASS,
    CM_OPERATION_TYPE_TRASPASS_NA,
    CM_TRASPASS_FORMAT_CCC,
    CM_PROC_BUY_FUND,
    CM_PROC_MONEY,
    CM_PROC_TRANSFER,
    CM_PROC_MONEY_TRANSFER,
    CM_PROC_INIT,
    CM_PROC_SUCCESS,
    CM_PROC_TRANSFER_ORDER,
    CM_PROC_MONEY_TRANSFER_ORDER,
} = require('../constants/constants');

const filterAccountChange = (accountId, associatedAccountNumber) => ({
    type: actionTypes.CM_FILTER_BY_ASSOCIATED_ACCOUNT,
    payload: {
        accountId,
        associatedAccountNumber,
    },
});

const setVisibleStep = step => ({
    type: actionTypes.CM_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

const getPortfolioListRequest = () => ({
    type: actionTypes.CM_GET_PORTFOLIOS_LIST_REQUEST,
});

const getPortfolioListError = data => ({
    type: actionTypes.CM_GET_PORTFOLIOS_LIST_ERROR,
    payload: data,
});

const getPortfolioListSuccess = data => ({
    type: actionTypes.CM_GET_PORTFOLIOS_LIST_SUCCESS,
    payload: data,
});

const getPortfolioList = () => dispatch => {
    const requestData = {
        query: {
            tipoPortfolioAccountTypeId: BROKER_CUSTOM_WALLET_PORTFOLIO_ACCOUNT_TYPE,
        },
    };

    dispatch(getPortfolioListRequest());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerCustomWalletGetPortfolios'),
        requestData,
    )
        .then(response => {
            dispatch(getPortfolioListSuccess(response));
        })
        .catch(response => {
            dispatch(getPortfolioListError(response.error));
        });
};

const onWalletChange = value => ({
    type: actionTypes.CM_FILTER_CHANGE_WALLET,
    payload: value,
});

const setWillLeave = () => ({
    type: actionTypes.CM_WILL_LEAVE,
});

//TODO: Add a confirmation when a user click con Cancel.
const setWillCancel = willCancel => ({
    type: actionTypes.CM_WILL_CANCEL,
    payload: {
        willCancel,
    },
});

const validateUIStep = step => ({
    type: actionTypes.CM_VALIDATE_STEP,
    payload: {
        step,
    },
});

const validateStepFromFunds = (step, originFund) => ({
    type: actionTypes.CM_FROM_FUNDS_VALIDATE_STEP,
    payload: {
        step,
        originFund,
    },
});

const validateStepTransferWithMoney = (step, originFund) => ({
    type: actionTypes.CM_TRANSFER_MONEY_VALIDATE_STEP,
    payload: {
        step,
        originFund,
    },
});

const resetStep = step => ({
    type: actionTypes.CM_RESET_STEP,
    data: {
        step,
    },
});

const confirmLeaveTransferMoneyToOtherPage = () => ({
    type: actionTypes.CM_LEAVE_TRANSFER_MONEY_TO_OTHER_PAGE_CONFIRMED,
});

const resetConsents = () => ({
    type: OKCONSENTS_RESET,
});

const activatePreLeaveModal = () => ({
    type: actionTypes.CM_ACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL,
});

const deactivatePreLeaveModal = () => ({
    type: actionTypes.CM_DEACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL,
});

const disableNextButton = () => ({
    type: actionTypes.CM_DISABLE_NEXT_BUTTON,
});

const enableNextButton = () => ({
    type: actionTypes.CM_ENABLE_NEXT_BUTTON,
});

const changeType = type => ({
    type: actionTypes.CM_SET_TYPE,
    payload: {
        type,
    },
});

const setAccountChanged = () => ({
    type: actionTypes.CM_SET_ACCOUNT_CHANGED,
});

const setOriginFund = fundId => ({
    type: actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_ORIGIN_FUND_ID,
    payload: {
        fundId,
    },
});

const saveOriginFundMatchedInPortfolio = (fundId, portfolioIsin) => ({
    type: actionTypes.CM_SET_FUND_ID_MATCHED_IN_PORTFOLIO,
    payload: {
        fundId,
        portfolioIsin,
    },
});

const resetOriginFund = () => ({
    type: actionTypes.CM_RESET_ORIGIN_FUND,
});

const getPortfolioInfoInProgress = () => ({
    type: actionTypes.FETCH_CM_PORTFOLIO_INFO_REQUEST,
});

const getPortfolioInfoSuccess = data => ({
    type: actionTypes.FETCH_CM_PORTFOLIO_INFO_SUCCESS,
    payload: {
        data,
    },
});

const getContractsAsOriginTransferInProgress = () => ({
    type: actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_REQUEST,
});

const getContractsAsOriginTransferSuccess = data => ({
    type: actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_SUCCESS,
    payload: {
        data,
    },
});

const getFundsMinAmountsInProgress = () => ({
    type: actionTypes.FETCH_CM_FUNDS_MIN_AMOUNTS_REQUEST,
});

const getFundsMinAmountsSuccess = data => ({
    type: actionTypes.FETCH_CM_FUNDS_MIN_AMOUNTS_SUCCESS,
    payload: {
        data,
    },
});

const postPortfolioOrderConfirmationInProgress = () => ({
    type: actionTypes.POST_CM_ORDER_CONFIRMATION_IN_PROGRESS,
});

const postPortfolioOrderConfirmationSuccess = data => ({
    type: actionTypes.POST_CM_ORDER_CONFIRMATION_SUCCESS,
    payload: {
        data,
    },
});

const postPortfolioOrderFromFundsConfirmationInProgress = () => ({
    type: actionTypes.POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_IN_PROGRESS,
});

const submitEmptyValidationFromFundsWithMoney = () => ({
    type: actionTypes.CM_SUBMIT_SUCCESSFUL,
});

const postPortfolioOrderFromFundsConfirmationSuccess = data => ({
    type: actionTypes.POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_SUCCESS,
    payload: {
        data,
    },
});

const validateWithAPIRequest = step => ({
    type: actionTypes.CM_VALIDATE_REQUEST,
    payload: {
        step,
    },
});

const validateWithAPISuccess = (step, data) => ({
    type: actionTypes.CM_VALIDATE_SUCCESS,
    payload: {
        step,
        data,
    },
});

const validateWithAPIFailure = (step, data) => ({
    type: actionTypes.CM_VALIDATE_FAILURE,
    payload: {
        step,
        data,
    },
});

const runCalculatorServiceRequest = step => ({
    type: actionTypes.CM_RUN_CALCULATOR_SERVICE_REQUEST,
    payload: {
        step,
    },
});

const runCalculatorServiceSuccess = (step, data) => ({
    type: actionTypes.CM_RUN_CALCULATOR_SERVICE_SUCCESS,
    payload: {
        step,
        data,
    },
});

const runCalculatorServiceFailure = (step, data) => ({
    type: actionTypes.CM_RUN_CALCULATOR_SERVICE_FAILURE,
    payload: {
        step,
        data,
    },
});

const runOrchestratorServiceRequest = () => ({
    type: actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_REQUEST,
});

const runOrchestratorServiceSuccess = data => ({
    type: actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_SUCCESS,
    payload: {
        data,
    },
});

const runOrchestratorServiceFailure = data => ({
    type: actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_FAILURE,
    payload: {
        data,
    },
});

const setAllDocumentsRead = () => (dispatch, getState) => {
    let boxes = getState().brokerLegalDocumentation.get('boxes');
    if (boxes) {
        const notAllRead = boxes.some(value => {
            return value.get('completed') === false;
        });
        dispatch({
            type: actionTypes.CM_VALIDATE_ALL_DOCUMENTS_READS_DIRTY,
            payload: {
                notAllRead,
            },
        });
    }
};

const saveOriginFundInfo = (originFundId, missingTransferFundAmount) => (
    dispatch,
    getState,
) => {
    const immAccounts = getState().accounts.get('byId');

    dispatch({
        type: actionTypes.CM_SAVE_ORIGIN_FUND_INFO,
        payload: {
            originFundId,
            immAccounts,
            missingTransferFundAmount,
        },
    });
};

const getPortfolioInfo = (amount, porfolioId, publicAmount, history) => dispatch => {
    const requestData = {
        header: {
            'Accept-Language': getLanguage().toUpperCase(),
        },
        query: {
            currency: EURO_TEXT,
            investmentAmount: amount,
            amountIndicator: amount > 0 && amount == publicAmount,
            portfolioId: [porfolioId],
        },
    };

    dispatch(getPortfolioInfoInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('portfolioInfo'), requestData)
        .then(response => dispatch(getPortfolioInfoSuccess(response)))
        .catch(response => {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

function buildPortfolioIsinsList(portfolio) {
    let list = [];
    portfolio.get('assetClassInfo').forEach(assetClass => {
        assetClass.get('subAssetClassInfo').forEach(subAssetClassInfo => {
            subAssetClassInfo
                .get('subAssetClassIsinInfo')
                .forEach(subAssetClassIsin => {
                    list.push(subAssetClassIsin.get('subAssetClassIsin'));
                });
        });
    });

    return list;
}

const getContractsAsOriginTransfer = (history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const portfolioIsins = buildPortfolioIsinsList(
        immCmWalletBuy.getIn(['portfolios', 0]),
    );

    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            cnuevo: {
                producto: '',
                numerodecontrato: '',
            },
            cviejo: {
                subgrupo: '',
                numerodecontrato: '',
            },
            portfolioAccountId: '',
            portfolioIsins,
        },
    };

    dispatch(getContractsAsOriginTransferInProgress());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioCustomerContracts'),
        requestData,
    )
        .then(response =>
            dispatch(getContractsAsOriginTransferSuccess(response)),
        )
        .catch(response => {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const getPortfolioRiskCategorizationSuccess = data => ({
    type: actionTypes.CM_GET_PORTFOLIO_RISK_CATEGORIZATION_SUCCESS,
    payload: {
        mostRestrictiveIsin: get(data, 'mostRestrictiveIsin'),
        riskPortfolioCategorization: get(data, 'riskPortfolioCategorization'),
        riskPortfolioMiFid2: get(data, 'riskPortfolioCategMifidIi'),
    },
});

function buildIntervenersData(interveners, additionalFields) {
    if (additionalFields) {
        return interveners.map(intervener => ({
            participantClass: intervener.get('interventionType'), // Intervention participant's type
            participantForm: intervener.get('interventionForm'),
            participantId: {
                participantNumber: intervener.get('personNumber').toString(),
                participantType: intervener.get('personType'),
            },
            participantName: intervener.get('name'),
            participantSurname: intervener.get('surname'),
        }));
    } else {
        return interveners.map(intervener => ({
            participantClass: intervener.get('interventionType'), // Intervention participant's type
            participantForm: intervener.get('interventionForm'),
            participantId: {
                participantNumber: intervener.get('personNumber').toString(),
                participantType: intervener.get('personType'),
            },
            participantName: intervener.get('name'),
            participantSurname: intervener.get('surname'),
        }));
    }
}

const buildOrderFundInfo = (portfolio, orderValidation, getState) => {
    const publicSiteUrl = getPublicSiteUrl();
    const immFeatureFlag = getState().flagBasedFeatures;
    const enableCostYield = immFeatureFlag.get(
        'wealth_build_portfolio_show_costs',
    );
    const list = [];
    portfolio.get('assetClassInfo').forEach(assetClassInfo => {
        assetClassInfo.get('subAssetClassInfo').forEach(subAssetClassInfo => {
            subAssetClassInfo
                .get('subAssetClassIsinInfo')
                .forEach(subAssetClassIsinInfo => {
                    const fund = orderValidation.find(
                        fund =>
                            fund.get('subAssetClassIsin') ===
                            subAssetClassIsinInfo.get('subAssetClassIsin'),
                    );
                    if (fund) {
                        const isin = fund.get('subAssetClassIsin');
                        list.push({
                            subAssetClassIsin: fund.get('subAssetClassIsin'),
                            subAssetClassFundAmount: fund.get(
                                'subAssetClassFundAmount',
                            ),
                            currency: subAssetClassIsinInfo.get('currency'),
                            nombreFondo: fund.get('subAssetClassFundName'),
                            contratoFondoTxt: fund.get('contratoFondoTxt'),
                            contratoFondo: {
                                fundContractIdNumber: fund.getIn([
                                    'contratoFondo',
                                    'fundContractIdNumber',
                                ]),
                                fundContractIdProduct: fund.getIn([
                                    'contratoFondo',
                                    'fundContractIdProduct',
                                ]),
                            },
                            codMonCuenta: CM_EUR_CURRENCY,
                            fechaDeValorLiquid: fund.get('fechaDeValorLiquid'),
                            operationType: fund.get('operationType'),
                            cuentaDomi: {
                                codbban: fund.getIn(['cuentaDomi', 'codbban']),
                                digitodecontrol: fund.getIn([
                                    'cuentaDomi',
                                    'digitodecontrol',
                                ]),
                                pais: fund.getIn(['cuentaDomi', 'pais']),
                            },
                            importeValorLiquidativo: {
                                divisa: fund.getIn([
                                    'importeValorLiquidativo',
                                    'divisa',
                                ]),
                                valorliquidativo: fund.getIn([
                                    'importeValorLiquidativo',
                                    'valorliquidativo',
                                ]),
                            },
                            assetClassId: fund.get('assetClassId'),
                            assetClassDesc: fund.get('assetClassDesc'),
                            subAssetClassId: fund.get('subAssetClassId'),
                            subAssetClassDesc: fund.get('subAssetClassDesc'),
                            fundSubproduct: fund.get('fundSubproduct'),
                            fundProduct: fund.get('fundProduct'),
                            orderMifidRequiredFields: {
                                // @TODO: Research where this object data can be provide for each order fund
                                reduceRisk: 'true', // For orders relating to derivatives on raw materials, this is an indication of whether the operation is intended to reduce the risk of another operation.
                                productPrice: '', // Price of the product @TODO: Research this fields
                            },
                            communServiceOrderData: {
                                conditionPrize: '', // Must be empty for carteras
                                orderCondition: 'A mercado', // Conditions of the order. Options: To market, for the best and Limit (A mercado, Por lo mejor, Limitada)
                                orderType: BROKER_ORDER_TYPE_BUY, // Type or the order. Options: Buy or sell. In this case 'Compra'
                                productType: BROKER_PRODUCT_TYPE_FUNDS_ES, // Type of the product, Options: shares, warrants, funds or etfs. In this case 'Funds'
                                sharesNumber: '1', // Number of shares
                                termValidity: '', // Must be empty for Carteras
                                idContract: fund.getIn([
                                    'contratoFondo',
                                    'fundContractIdNumber',
                                ]), // Contract Identificator, Sample: '12345'
                            },
                            communServiceDocumDate: {
                                marketingReport: `${publicSiteUrl}/assets/static/pdf/fondos/memorias/${isin}.pdf`,
                                costYield: enableCostYield
                                    ? null
                                    : fund.get('costYield'),
                            },
                        });
                    }
                });
        });
    });
    return list;
};

function generateMiFIDDisclaimers(immBrokerConvenienceMiFIDTest) {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'usPersonDisclaimers',
    ]);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'disclaimers',
    ]);
    const immAllDisclaimers = Immutable.fromJS([])
        .merge(immUSPersonDisclaimers)
        .merge(immDisclaimers);

    return immAllDisclaimers
        .map(immDisclaimer => immDisclaimer.get('description'))
        .join(' | ');
}

function getDisclaimers(immBrokerConvenienceMiFIDTest) {
    const mifidv2AllDisclaimers = immBrokerConvenienceMiFIDTest
        .getIn(['mifidv2', 'disclaimers'])
        .merge(
            immBrokerConvenienceMiFIDTest.getIn([
                'mifidv2',
                'usPersonDisclaimers',
            ]),
        )
        .toJS();

    const disclaimers = mifidv2AllDisclaimers.reduce(
        (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer${index + 1}`;
            const disclaimerText = trim(get(disclaimer, 'description'));

            result[disclaimerKey] = `${trim(
                get(disclaimer, 'id'),
            )} | ${disclaimerText}`;

            return result;
        },
        {},
    );

    return disclaimers;
}

const postPortfolioOrderConfirmation = (dispatch, getState, dataToken, history) => {
    const immProfile = getState().profile;

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const immCmWalletBuy = getState().cm;
    const portfolio = immCmWalletBuy.getIn(['portfolios', 0]);
    const necessaryTargetScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'scoring',
    ]);
    const testResultScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'score',
    ]);

    const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
    const accountNumber = step1.get('accountNumber');
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumber);
    const accountNumberCCC = immAccount.getIn(['ibanComplex', 'codbban']);

    const accountContractNumber = immAccount.get('contractNumber');
    const accountIdProduct = immAccount.get('product');
    const additionalFields = true;
    const interveners = step1.get('interveners');
    const portfolioOrderIntervInfo = buildIntervenersData(
        interveners,
        additionalFields,
    ).toJS();
    const isTransferWithMoney = step1.get('isTransferWithMoney');

    let portfolioOrderFundInfo;
    let orderValidation;

    if (isTransferWithMoney) {
        recordLink(
            PROC_SIGNATURE_PATTERN,
            CM_PROC_INIT,
            CM_PROC_MONEY_TRANSFER_ORDER,
        );
        orderValidation = immCmWalletBuy.getIn(
            ['orderValidation', 'portfolioOrderValidTransferOk'],
            [],
        );
        const validOrderResultOutputOk = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioOrderValidationOutput',
            'validOrderResultOutputOk',
        ]);
        portfolioOrderFundInfo = buildOrderFundInfo(
            portfolio,
            validOrderResultOutputOk,
            getState,
        );
    } else {
        orderValidation = immCmWalletBuy.getIn(
            ['orderValidation', 'validOrderResultOutputOk'],
            [],
        );
        portfolioOrderFundInfo = buildOrderFundInfo(
            portfolio,
            orderValidation,
            getState,
        );
    }

    const requestData = {
        header: {
            'Accept-Language': getLanguage().toUpperCase(),
        },
        query: {
            dataToken,
            portfolioOrderType: 'L', // Indicates if buy's origin is 'Liquidez' ('L'), 'Traspaso' ('T'), ó 'Traspaso + Liquidez' ('B'). For now the field is always 'Liquidez'.
            portfolioOrderCustomerInfo: {
                partenonAccountNumber: {
                    accountContractNumber,
                    accountIdProduct,
                },
                cviejo: {
                    subgrupo: accountIdProduct,
                    numerodecontrato: accountContractNumber,
                },
                dateOrder: moment().format('YYYY-MM-DD'),
                portfolioOrderIntervInfo,
                portfolioMifidRequiredFields: {
                    // Motor Mifid v2
                    convenienceTest: immBrokerConvenienceMiFIDTest.getIn([
                        'mifidv2',
                        'getTestOperationCode',
                    ]), // 'Convenience Test Disclaimer ID',
                    convenientRegistry: immBrokerConvenienceMiFIDTest.getIn([
                        'mifidv2',
                        'isConvenient',
                    ]), // Indicates if the operation is convenient.
                    evaluatetRegistry: immBrokerConvenienceMiFIDTest.get(
                        'started',
                    ), // Indicates if the operation has been evaluated. Motor Mifid
                    disclaimers: getDisclaimers(immBrokerConvenienceMiFIDTest),
                    marketTargetRegistry:
                        testResultScore >= necessaryTargetScore, // Indicates if the test result is greater than the target market of the product that the issuer.
                    necessaryConvenienceTestNote: necessaryTargetScore,
                    necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(
                        ['mifidv2', 'targetMarketKnowledgeAndExperience'],
                    ), // Note that must be overcomed in the Target Market.
                    testConvenienceResult: testResultScore, // Current note obtained by the payer in the convenience test.
                    agentId: CHANGE_AGENT_ID, // Agent that supported the operation
                },
                portfolioServiceGeneralData: {
                    channel: CONNECTION_CHANNEL_INTERNET, // Connection channel: internet or intranet
                    clientAlias: immProfile.get('nombreCliente'),
                    ccc: accountNumberCCC, // Associated Current Account. Sample: '00730100530562931170'
                    mifidWarningText: generateMiFIDDisclaimers(
                        immBrokerConvenienceMiFIDTest,
                    ),
                    email: PersonalDataHelper.getEmail(immProfile),
                },
            },
            portfolioOrderInfo: {
                portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                investmentAmount: immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'amount',
                ]),
                currency: EURO_TEXT,
                subAssetClassIndIsin: immCmWalletBuy.getIn([
                    'simulation',
                    'type',
                ]),
                portfolioOrderFundInfo,
            },
        },
    };

    dispatch(postPortfolioOrderConfirmationInProgress());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioOrderConfirmationV2'),
        requestData,
    )
        .then(response => {
            if (isTransferWithMoney) {
                recordLink(
                    PROC_SIGNATURE_PATTERN,
                    CM_PROC_SUCCESS,
                    CM_PROC_MONEY_TRANSFER_ORDER,
                );
            }
            dispatch(postPortfolioOrderConfirmationSuccess(response));
        })
        .catch(response => {
            recordProcess(PROC_BUY_GDI, PROC_FAIL);
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

function parseDestinationFundData(fund) {
    return {
        subAssetClassFundShares: fund.get('subAssetClassFundShares'),
        subAssetClassId: fund.get('subAssetClassId'),
        assetClassId: fund.get('assetClassId'),
        subAssetClassFundAmount: fund.get('subAssetClassFundAmount'),
        currency: fund.get('currency'),
        fullContratoDigitoControlDest: fund.get(
            'fullContratoDigitoControlDest',
        ),
        codigoFondoDestino: fund.get('codigoFondo'),
        subAssetClassIsin: fund.get('subAssetClassIsin'),
        tipodeproductoContratoDestino: fund.get(
            'tipodeproductoContratoDestino',
        ),
        subAssetClassFundName: fund.get('subAssetClassFundName'),
        subtipoContratoDestino: fund.get('subtipoContratoDestino'),
        subAssetClassDesc: fund.get('subAssetClassDesc'),
        assetClassDesc: fund.get('assetClassDesc'),
        subAssetClassFundsContractDest: {
            subAssetClassFundsContractDestIdProduct: fund.getIn([
                'subAssetClassFundsContractDest',
                'subAssetClassFundsContractDestIdProduct',
            ]),
            subAssetClassFundsContractIDestIdNumber: fund.getIn([
                'subAssetClassFundsContractDest',
                'subAssetClassFundsContractIDestIdNumber',
            ]),
        },
        fundProduct: fund.get('tipodeproductoContratoDestino'),
        fundSubproduct: fund.get('subtipoContratoDestino'),
    };
}

const postPortfolioOrderConfirmationFromFunds = (
    dispatch,
    getState,
    dataToken,
    history
) => {
    const immCmWalletBuy = getState().cm;
    const immProfile = getState().profile;
    const publicSiteUrl = getPublicSiteUrl();
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const necessaryTargetScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'scoring',
    ]);
    const testResultScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'score',
    ]);
    const originFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundInfo',
    ]);
    const originFundInterveners = originFundInfo.get('listadoIntervinientes');
    const accountNumberTransfer = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'accountNumberTransfer',
    ]);
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumberTransfer);
    const accountNumberCCC = immAccount.getIn(['ibanComplex', 'codbban']);

    const requestData = {
        header: {
            'Accept-Language': getLanguage().toUpperCase(),
            openBankAuthToken: dataToken,
            'Content-Type': 'application/json',
        },
        query: {
            dataToken,
            portfolioOrderType: 'T',
            portfolioTransferCustomerInfo: {
                dateOrder: moment().format('YYYY-MM-DD'),
                portfolioMifidRequiredFields: {
                    // Motor Mifid v2
                    convenienceTest: immBrokerConvenienceMiFIDTest.getIn([
                        'mifidv2',
                        'getTestOperationCode',
                    ]), // 'Convenience Test Disclaimer ID',
                    convenientRegistry: immBrokerConvenienceMiFIDTest.getIn([
                        'mifidv2',
                        'isConvenient',
                    ]), // Indicates if the operation is convenient.
                    evaluatetRegistry: immBrokerConvenienceMiFIDTest.get(
                        'started',
                    ), // Indicates if the operation has been evaluated. Motor Mifid
                    disclaimers: getDisclaimers(immBrokerConvenienceMiFIDTest),
                    necessaryConvenienceTestNote: immBrokerConvenienceMiFIDTest.getIn(
                        ['mifidv2', 'scoring'],
                    ),
                    marketTargetRegistry:
                        testResultScore >= necessaryTargetScore, // Indicates if the test result is greater than the target market of the product that the issuer.
                    necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(
                        ['mifidv2', 'targetMarketKnowledgeAndExperience'],
                    ), // Note that must be overcomed in the Target Market.
                    testConvenienceResult: testResultScore, // Current note obtained by the payer in the convenience test.
                    agentId: CHANGE_AGENT_ID, // Agent that supported the operation
                },
                fundTransferIntervInfo: originFundInterveners
                    .get('intervinientes')
                    .map(intervener => ({
                        tipoIntervencion: intervener.get('tipoIntervencion'),
                        ordenIntervencion: intervener.get('ordenIntervencion'),
                        identifDocumento: {
                            codigodedocumento: intervener.getIn([
                                'identifDocumento',
                                'codigodedocumento',
                            ]),
                            tipodocumentoofic: intervener.getIn([
                                'identifDocumento',
                                'tipodocumentoofic',
                            ]),
                        },
                        nomInterviniente: intervener.get('nomInterviniente'),
                    }))
                    .toJS(),
                portfolioServiceGeneralData: {
                    channel: CONNECTION_CHANNEL_INTERNET, // Connection channel: internet or intranet
                    ccc: IbanHelper.formatAccountTextWithSpaces(
                        accountNumberCCC,
                        CM_TRASPASS_FORMAT_CCC,
                    ), // Associated Current Account. Sample: '00730100530562931170'
                    clientAlias: immProfile.get('nombreCliente'),
                    mifidWarningText: generateMiFIDDisclaimers(
                        immBrokerConvenienceMiFIDTest,
                    ),
                    email: PersonalDataHelper.getEmail(immProfile),
                },
            },
            portfolioDestTransferInfo: {
                currency: CM_EUR_CURRENCY,
                investmentAmount: immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'amount',
                ]),
                portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                subAssetClassIndIsin: immCmWalletBuy.getIn([
                    'simulation',
                    'type',
                ]),
                portfolioDestTransferFundInfo: immCmWalletBuy
                    .getIn(['orderValidation', 'portfolioOrderValidTransferOk'])
                    .map(fund => ({
                        communServiceOrderData: {
                            conditionPrize: '', // Must be empty for carteras
                            orderCondition: 'A mercado', // Conditions of the order. Options: To market, for the best and Limit (A mercado, Por lo mejor, Limitada)
                            orderType: BROKER_ORDER_TYPE_BUY, // Type or the order. Options: Buy or sell. In this case 'Compra'
                            productType: BROKER_PRODUCT_TYPE_FUNDS_ES, // Type of the product, Options: shares, warrants, funds or etfs. In this case 'Funds'
                            sharesNumber: '', // Number of shares
                            termValidity: '', // Must be empty for carteras
                        },
                        communServiceDocumDate: {
                            marketingReport: `${publicSiteUrl}/assets/static/pdf/fondos/memorias/${fund.getIn(
                                ['destinationFundData', 'subAssetClassIsin'],
                            )}.pdf`, //URL Memoria de comercialización
                            costYield: fund.getIn([
                                'destinationFundData',
                                'costYield',
                            ]), //Nombre del pdf que se genera si se contrata el fondo. Obtenido de la llamada a validación
                        },
                        transferFundData: {
                            fechaValor: fund.get('fechaValor'),
                            operationType: fund.get('operationType'),
                            transferTypeTotalPartial: fund.get(
                                'transferTypeTotalPartial',
                            ),
                            originFundData: {
                                codigoIsinOrigen: fund.getIn([
                                    'originFundData',
                                    'isinOrigen',
                                ]),
                                subtipoContratoOrigen: fund.getIn([
                                    'originFundData',
                                    'subtipoContratoOrigen',
                                ]),
                                claveFondoContrOrigen: fund.getIn([
                                    'originFundData',
                                    'claveFondoContrOrigen',
                                ]),
                                tipodeproductoContratoOrigen: originFundInfo.getIn(
                                    [
                                        'infoFondosPosicionGlobal',
                                        'contrato',
                                        'producto',
                                    ],
                                ),
                                contratoOrigen: {
                                    producto: originFundInfo.getIn([
                                        'infoFondosPosicionGlobal',
                                        'contrato',
                                        'producto',
                                    ]),
                                    numerodecontrato: originFundInfo.getIn([
                                        'infoFondosPosicionGlobal',
                                        'contrato',
                                        'numeroContrato',
                                    ]),
                                },
                            },
                            destinationFundData: parseDestinationFundData(
                                fund.get('destinationFundData'),
                            ),
                        },
                        ctaAsociada: fund.get('ctaAsociada'),
                        importeDispMonedaFondo: fund.get(
                            'importeDispMonedaFondo',
                        ),
                        subgrupoCtaAsociada: fund.get('subgrupoCtaAsociada'),
                        saldoDia: fund.get('saldoDia'),
                        ultimoValorLiquidativo: parseFloat(
                            fund.get('ultimoValorLiquidativo'),
                        ),
                        icsaldod: fund.get('icsaldod'),
                        tipoTraspasoTotalParcial: fund.get(
                            'transferTypeTotalPartial',
                        ),
                        indAltaFondoDest: fund.getIn([
                            'destinationFundData',
                            'indAltaFondoDestino',
                        ]),
                        participacTraspaso: fund.getIn([
                            'destinationFundData',
                            'participacTraspaso',
                        ]),

                        campox: 'P',
                        cantidadPorRepartir: '0',
                        tipodeproductoCtaAsociada: fund.getIn([
                            'ctaAsociada',
                            'subgrupo',
                        ]),
                        tipoDocumento: 'P',
                        tipoUnidadTraspaso: 'P',

                        importeTraspaso: {
                            importe: fund.getIn([
                                'destinationFundData',
                                'subAssetClassFundAmount',
                            ]),
                            divisa: fund.getIn([
                                'destinationFundData',
                                'currency',
                            ]),
                        },
                        orderMifidRequiredFields: {
                            productPrice: '',
                            reduceRisk: 'true',
                        },
                    })),
            },
        },
    };

    dispatch(postPortfolioOrderFromFundsConfirmationInProgress());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioTransferConfirmation'),
        requestData,
    )
        .then(response => {
            dispatch(postPortfolioOrderFromFundsConfirmationSuccess(response));
        })
        .catch(response => {
            recordProcess(PROC_BUY_GDI, PROC_FAIL);
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const portfolioOrderConfirmation = (transferFromFunds, history) => (
    dispatch,
    getState,
) => {
    let callback;
    if (!transferFromFunds) {
        callback = (dispatch, getState, dataToken) => {
            dispatch(updateConsents(dataToken))
                .then(() =>
                    postPortfolioOrderConfirmation(
                        dispatch,
                        getState,
                        dataToken,
                        history
                    ),
                )
                .catch(() =>
                    postPortfolioOrderConfirmation(
                        dispatch,
                        getState,
                        dataToken,
                        history
                    ),
                );
        };
    } else {
        callback = (dispatch, getState, dataToken) => {
            dispatch(updateConsents(dataToken))
                .then(() =>
                    postPortfolioOrderConfirmationFromFunds(
                        dispatch,
                        getState,
                        dataToken,
                        history
                    ),
                )
                .catch(() =>
                    postPortfolioOrderConfirmationFromFunds(
                        dispatch,
                        getState,
                        dataToken,
                        history
                    ),
                );
        };
    }

    const isAlreadyFetching = getState().investmentFunds.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(
                dispatch,
                getState,
                callback,
            );
        });
    }
};

const getIntervenersSuccess = data => ({
    type: actionTypes.CM_GET_INTERVENERS_SUCCESS,
    payload: {
        data,
    },
});

const getIntervenersError = data => ({
    type: actionTypes.CM_GET_INTERVENERS_ERROR,
    payload: {
        data,
    },
});

const getIntervenerRequest = () => ({
    type: actionTypes.CM_GET_INTERVENERS_REQUEST,
});

const portfolioRiskCategorizationRequest = () => ({
    type: actionTypes.FETCH_CM_PORTFOLIO_RISK_CATEGORIZATION_INFO_REQUEST,
});

const getInterveners = accountNumber => (dispatch, getState) => {
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumber);
    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');

    const requestData = {
        query: {
            producto: productNumber,
            numeroContrato: contractNumber,
        },
    };

    dispatch(getIntervenerRequest());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerGetIntervenersInvestment'),
        requestData,
    )
        .then(response => dispatch(getIntervenersSuccess(response)))
        .catch(response => dispatch(getIntervenersError(response.error)));
};

const restoreDefaultInterveners = originalInterveners => ({
    type: actionTypes.CM_RESTORE_DEFAULT_INTERVENERS,
    payload: {
        originalInterveners,
    },
});

const setIntervenerName = (index, name, originalInterveners) => ({
    type: actionTypes.CM_SET_ACCOUNT_INTERVENER_NAME,
    payload: {
        index,
        name,
        originalInterveners,
    },
});

const setAccount = (
    accountId,
    accountAmount,
    contractNumber,
    productNumber,
    oldFullContractNumber,
) => ({
    type: actionTypes.CM_SET_ACCOUNT,
    payload: {
        accountId,
        accountAmount,
        productNumber,
        contractNumber,
        oldFullContractNumber,
    },
});

const changeSelectedAccount = (
    accountId,
    accountAmount,
    contractNumber,
    productNumber,
    oldFullContractNumber,
) => dispatch => {
    dispatch(
        setAccount(
            accountId,
            accountAmount,
            contractNumber,
            productNumber,
            oldFullContractNumber,
        ),
    );
    dispatch(getInterveners(accountId));
};

const setAmount = amount => ({
    type: actionTypes.CM_SET_AMOUNT,
    payload: {
        amount,
    },
});

const setInitialAmount = amount => ({
    type: actionTypes.CM_SET_INITIAL_AMOUNT,
    payload: {
        amount,
    },
});

const changeDisclaimerCheck = value => ({
    type: actionTypes.CM_LEGAL_DISCLAIMER_CHANGED,
    payload: {
        value,
    },
});

const removeIntervener = (index, originalInterveners) => ({
    type: actionTypes.CM_REMOVE_INTERVENER,
    payload: {
        index,
        originalInterveners,
    },
});

const addIntervener = () => ({
    type: actionTypes.CM_ADD_INTERVENER,
});

const setIntervenerType = (index, type) => ({
    type: actionTypes.CM_SET_INTERVENER_TYPE,
    payload: {
        index,
        type,
    },
});

const getPortfolioRiskCategorization = (portfolioId, history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const fundsType = immCmWalletBuy.getIn(['simulation', 'type']);

    const requestData = {
        header: {
            'Accept-Language': getLanguage().toUpperCase(),
        },
        query: {
            portfolioId,
            subAssetClassIndIsin: fundsType,
        },
    };

    dispatch(portfolioRiskCategorizationRequest());
    APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioRiskCategorization'),
        requestData,
    ).then(
        response => {
            const invalidResponse =
                response.riskPortfolioCategorization == null ||
                response.riskPortfolioCategorization === '0' ||
                response.mostRestrictiveIsin == null ||
                response.riskPortfolioCategMifidIi == null;
            if (invalidResponse) {
                dispatch(errorActions.show('', true, history));
                return;
            }
            dispatch(getPortfolioRiskCategorizationSuccess(response));
        },
        () => dispatch(errorActions.show('', true, history)),
    );
};

function buildPortfolioOrderValidFundsData(portfolio) {
    let list = [];
    portfolio.get('assetClassInfo').forEach(assetClass => {
        assetClass.get('subAssetClassInfo').forEach(subAssetClassInfo => {
            subAssetClassInfo
                .get('subAssetClassIsinInfo')
                .forEach(subAssetClassIsin => {
                    list.push({
                        currency: subAssetClassIsin.get('currency'),
                        subAssetClassFundAmount: subAssetClassIsin.get(
                            'subAssetClassFundAmount',
                        ),
                        subAssetClassIsin: subAssetClassIsin.get(
                            'subAssetClassIsin',
                        ),
                    });
                });
        });
    });

    return list;
}

function buildPortfolioOrderValidFundsDataTransferMoney(portfolio) {
    let list = [];
    portfolio.get('assetClassInfo').forEach(assetClass => {
        assetClass.get('subAssetClassInfo').forEach(subAssetClassInfo => {
            subAssetClassInfo
                .get('subAssetClassIsinInfo')
                .forEach(subAssetClassIsin => {
                    list.push({
                        currency: subAssetClassIsin.get('currency'),
                        subAssetClassFundAmount: subAssetClassIsin.get(
                            'subAssetClassFundAmount',
                        ),
                        subAssetClassIsin: subAssetClassIsin.get(
                            'subAssetClassIsin',
                        ),
                    });
                });
        });
    });

    return list;
}

function buildPortfolioOrderCalculatorFundsData(portfolio) {
    let list = [];
    portfolio.get('assetClassInfo').forEach(assetClass => {
        assetClass.get('subAssetClassInfo').forEach(subAssetClassInfo => {
            subAssetClassInfo
                .get('subAssetClassIsinInfo')
                .forEach(subAssetClassIsin => {
                    list.push({
                        currency: subAssetClassIsin.get('currency'),
                        subAssetClassFundAmount: subAssetClassIsin.get(
                            'subAssetClassFundAmount',
                        ),
                        subAssetClassIsin: subAssetClassIsin.get(
                            'subAssetClassIsin',
                        ),
                        assetClassId: assetClass.get('assetClassId'),
                        subAssetClassId: subAssetClassInfo.get(
                            'subAssetClassId',
                        ),
                    });
                });
        });
    });

    return list;
}

function buildPortfolioOrderValidFundsDataFromMoney(portfolio) {
    let list = [];
    portfolio.forEach(fund => {
        if (
            fund.get('operationType') ===
            CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE
        ) {
            list.push({
                currency: fund.get('currency'),
                subAssetClassFundAmount: fund.get('subAssetClassFundAmount'),
                subAssetClassIsin: fund.get('subAssetClassIsin'),
                operationType: CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE,
                fullContratoDigitoControlDest: fund.get(
                    'fullContratoDigitoControlDest',
                ),
                contratoFondoDest: fund.get('contratoFondoDest')
                    ? fund.get('contratoFondoDest').toJS()
                    : {
                          fundContractDestIdProduct: null,
                          fundContractIDestdNumber: null,
                      },
            });
        } else {
            list.push({
                currency: fund.get('currency'),
                subAssetClassFundAmount: fund.get('subAssetClassFundAmount'),
                subAssetClassIsin: fund.get('subAssetClassIsin'),
                operationType: CM_HIRE_OPERATION_TYPE,
            });
        }
    });

    return list;
}

function buildPortfolioOrderValidFundsDataFromTransferMoney(
    destFundsTransferCalculatorOutputListFilter,
) {
    let list = [];
    destFundsTransferCalculatorOutputListFilter.forEach(destFund => {
        if (
            destFund.get('operationType') ===
            CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE
        ) {
            list.push({
                currency: CM_EUR_CURRENCY,
                subAssetClassFundAmount: destFund.get(
                    'subAssetClassFundAmount',
                ),
                subAssetClassIsin: destFund.get('subAssetClassIsin'),
                operationType: CM_ADDITIONAL_SUBSCRIPTION_OPERATION_TYPE,
                transfer_liquidity: destFund.get('transfer_liquidity'),
                fullContratoDigitoControlDest: destFund.get(
                    'fullContratoDigitoControlDest',
                ),
                contratoFondoDest: {
                    constractDestIdProduct:
                        destFund.getIn([
                            'fundContractDest',
                            'fundContractDestIdProduct',
                        ]) || null,
                    contratcDestIdNumber:
                        destFund.getIn([
                            'fundContractDest',
                            'fundContractDestIdNumber',
                        ]) || null,
                },
            });
        } else {
            list.push({
                currency: CM_EUR_CURRENCY,
                subAssetClassFundAmount: destFund.get(
                    'subAssetClassFundAmount',
                ),
                subAssetClassIsin: destFund.get('subAssetClassIsin'),
                operationType: CM_HIRE_OPERATION_TYPE,
            });
        }
    });

    return list;
}

const validateWithAPI = (step, history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const intervenersData = buildIntervenersData(
        immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP, 'interveners']),
    );
    const validatedOriginFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_SECOND_STEP,
        'originFund',
    ]);
    const destFundsTransferCalculatorOutputList =
        validatedOriginFundInfo &&
        validatedOriginFundInfo.getIn([
            'destFundsOrderCalculatorOutput',
            'destFundOrderCalculatorList',
        ]);
    const portfolioOrderValidFundsData = buildPortfolioOrderValidFundsDataFromMoney(
        destFundsTransferCalculatorOutputList,
    );
    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            portfolioOrderValidCustumerInfo: {
                portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                availableAmount: immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'accountAmount',
                    'amount',
                ]),
                currency: immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'accountAmount',
                    'currency',
                ]),
                subAssetClassIndIsin: immCmWalletBuy.getIn([
                    'simulation',
                    'type',
                ]),
                partenonAccountNumber: {
                    accountContractNumber: immCmWalletBuy.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'selectedAccount',
                        'contractNumber',
                    ]),
                    accountIdProduct: immCmWalletBuy.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'selectedAccount',
                        'productNumber',
                    ]),
                },
                portfolioOrderIntervInfo: intervenersData.toJS(),
            },
            portfolioOrderValidInfo: {
                portfolioOrderValidFundInfo: portfolioOrderValidFundsData,
            },
        },
    };

    dispatch(validateWithAPIRequest(step));
    APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioOrderValidationV3'),
        requestData,
    ).then(
        data => {
            if (get(data, 'validOrderResultOutputOk', []).length > 0) {
                dispatch(validateWithAPISuccess(step, data));
                dispatch(validateUIStep(step)); // We must validate again in order to move to step 2
            } else {
                dispatch(validateWithAPIFailure(step, data));
                dispatch(errorActions.show('', true, history)); // @TODO: In case that the service has a numeric key code, pass as parameter in errorActions.show()
            }
        },
        data => {
            dispatch(validateWithAPIFailure(step, data));
            dispatch(errorActions.show('', true, history)); // @TODO: In case that the service has a numeric key code, pass as parameter in errorActions.show()
        },
    );
};

const validateWithApiFromFunds = step => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const originFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundInfo',
    ]);
    const originFundMatchedInPortfolio = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundMatchedInPortfolio',
    ]);
    const originFundInterveners = originFundInfo.get('listadoIntervinientes');
    const validatedOriginFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_SECOND_STEP,
        'originFund',
    ]);
    const destFundsTransferCalculatorOutputList = validatedOriginFundInfo.getIn(
        ['destFundsTransferCalculatorOutput', 'destFundTransferCalculatorList'],
    );
    const destFundsTransferCalculatorOutputListFilter = destFundsTransferCalculatorOutputList.filter(
        destFund =>
            destFund
                .get('operationType')
                .startsWith(CM_OPERATION_TYPE_TRASPASS) &&
            destFund.get('operationType') !== CM_OPERATION_TYPE_TRASPASS_NA &&
            destFund.getIn(['fundContractDest', 'fundContractDestIdNumber']) !==
                originFundMatchedInPortfolio,
    );
    const originFundsTransferCalculatorOutput = validatedOriginFundInfo.get(
        'originFundsTransferCalculatorOutput',
    );
    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            portfolioOrderValidTransferOriginInfo: {
                originFundAmount: originFundsTransferCalculatorOutput.get(
                    'originFundAmount',
                ),
                originFundAmountCurrency: CM_EUR_CURRENCY,
                fundContractOri: {
                    fundContractOriIdProduct: originFundsTransferCalculatorOutput.getIn(
                        ['fundContractOri', 'fundContractOriIdProduct'],
                    ),
                    fundContractOriIdNumber: originFundsTransferCalculatorOutput.getIn(
                        ['fundContractOri', 'fundContractOriIdNumber'],
                    ),
                },
                portfolioOrderValidTransferIntervInfo: originFundInterveners
                    .get('intervinientes')
                    .map(intervener => ({
                        participantClass: intervener.get('ordenIntervencion'),
                        participantForm: intervener.get('tipoIntervencion'),
                        participantId: {
                            participantNumber: intervener.getIn([
                                'identifDocumento',
                                'codigodedocumento',
                            ]),
                            participantType: intervener.getIn([
                                'identifDocumento',
                                'tipodocumentoofic',
                            ]),
                        },
                    })),
            },
            portfolioOrderValidTransferDestInfo: {
                portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                subAssetClassIndIsin: immCmWalletBuy.getIn([
                    'simulation',
                    'type',
                ]),
                portfolioOrderValidTransferFundInfo: destFundsTransferCalculatorOutputListFilter.map(
                    destFund => ({
                        subAssetClassIsin: destFund.get('subAssetClassIsin'),
                        subAssetClassFundAmount: destFund.get(
                            'subAssetClassFundAmount',
                        ),
                        subAssetClassFundShares: destFund.get(
                            'subAssetClassFundShares',
                        ),
                        currency: CM_EUR_CURRENCY,
                        operationType: destFund.get('operationType'),
                        transferTypeTotalPartial: destFund.get(
                            'transferTypeTotalPartial',
                        ),
                        fundContractDest: {
                            fundContractDestIdProduct:
                                destFund.getIn([
                                    'fundContractDest',
                                    'fundContractDestIdProduct',
                                ]) || '', //TODO maria. Change this
                            fundContractIDestIdNumber:
                                destFund.getIn([
                                    'fundContractDest',
                                    'fundContractDestIdNumber',
                                ]) || '', //TODO maria. Change this
                        },
                        fullContratoDigitoControlDest: destFund.get(
                            'fullContratoDigitoControlDest',
                        ),
                    }),
                ),
            },
        },
    };

    dispatch(validateWithAPIRequest(step));
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioOrderValidTransfer'),
        requestData,
    )
        .then(response => {
            dispatch(validateWithAPISuccess(step, response));
            dispatch(validateStepFromFunds(step)); //we must validate again in order to move to step 3 mover al otp
        })
        .catch(response => {
            dispatch(validateWithAPIFailure(step, response));
        });
};

const runCalculatorServiceFromTransferMoney = (step, originFundId) => (
    dispatch,
    getState,
) => {
    const immCmWalletBuy = getState().cm;
    const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
    const originFund = step1.getIn([
        'originFundInfo',
        'infoFondosPosicionGlobal',
    ]);
    const immAccounts = getState().accounts.get('byId');
    const accountNumber = step1.get('accountNumber');
    const immAccount = immAccounts.get(accountNumber);
    const originFundInterveners = step1.getIn([
        'originFundInfo',
        'listadoIntervinientes',
    ]);
    const interveners = step1.get('interveners');
    const totalAmount = step1.get('amount');
    const portfolioOrderValidFundsData = buildPortfolioOrderValidFundsDataTransferMoney(
        immCmWalletBuy.getIn(['portfolios', 0]),
    );
    const allFundsInfo = step1.get('infoFondosTodos');

    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            originFundTransferCalculatorInfo: {
                fullContratoDigitoControlOri: originFund.get(
                    'fullContratoDigitoControl',
                ),
                fundContractOri: {
                    fundContractOriIdProduct: originFund.getIn([
                        'contrato',
                        'producto',
                    ]),
                    fundContractOriIdNumber: originFund.getIn([
                        'contrato',
                        'numeroContrato',
                    ]),
                },
                originFundAmount: originFund.getIn([
                    'importes',
                    'total',
                    'valor',
                    'importeEur',
                    'importe',
                ]),
                originFundAmountCurrency: CM_EUR_CURRENCY,
                originFundSharesAmount:
                    originFund.getIn([
                        'importes',
                        'total',
                        'participaciones',
                    ]) || 0,
                originFundIsin: originFund.getIn([
                    'instrumentInfo',
                    'instrumentId',
                ]),
                originFundSubtipo: originFund.get('subtipoProducto'),
                originFundAccountInfo: {
                    cviejo: {
                        subgrupo: originFund.getIn([
                            'cuentaAsociada',
                            'subgrupo',
                        ]),
                        numerodecontrato: originFund.getIn([
                            'cuentaAsociada',
                            'numeroContrato',
                        ]),
                    },
                    accountAvailableAmount: {
                        availableAmount: originFund.getIn([
                            'cuentaAsociada',
                            'saldo',
                            'importe',
                        ]),
                        availableAmountCurrency: CM_EUR_CURRENCY,
                    },
                },
                originFundTransferIntervInfo: originFundInterveners
                    .get('intervinientes')
                    .map(intervener => ({
                        identifDocumento: {
                            tipodocumentoofic: intervener.getIn([
                                'identifDocumento',
                                'tipodocumentoofic',
                            ]),
                            codigodedocumento: intervener.getIn([
                                'identifDocumento',
                                'codigodedocumento',
                            ]),
                        },
                        nomInterviniente: intervener.get('nomInterviniente'),
                        tipoIntervencion: intervener.get('tipoIntervencion'),
                        ordenIntervencion: intervener.get('ordenIntervencion'),
                    })),
            },
            originAccountCalculatorInfo: {
                cviejo: {
                    subgrupo: immAccount.get('product'),
                    numerodecontrato: immAccount.get('contractNumber'),
                },
                partenonAccountNumber: {
                    accountIdProduct: immAccount.get('product'),
                    accountContractNumber: immAccount.get('contractNumber'),
                },
                accountAvailableAmount: {
                    availableAmount: step1.getIn(['accountAmount', 'amount']),
                    availableAmountCurrency: CM_EUR_CURRENCY,
                },
                originAccountIntervInfo: interveners.map(intervener => ({
                    desIntervencion: intervener.get('type'),
                    participantForm: intervener.get('interventionForm'),
                    participantClass: intervener.get('interventionType'),
                    participantId: {
                        participantNumber: intervener.get('personNumber'),
                        participantType: intervener.get('personType'),
                    },
                })),
            },
            destinationFundTransferCalculatorInfo: {
                fundTransferCalculatorPortfolioInfo: {
                    portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                    subAssetClassIndIsin: immCmWalletBuy.getIn([
                        'simulation',
                        'type',
                    ]),
                    destinationPortfolioTotalAmount: {
                        portfolioTotalAmount: totalAmount,
                        portfolioTotalCurrency: CM_EUR_CURRENCY,
                    },
                },
                fundTransferPortfolioFundsInfo: portfolioOrderValidFundsData,
            },
            infoFondosTodos: allFundsInfo,
        },
    };

    dispatch(runCalculatorServiceRequest(step));
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('cashFundsPortfolioOrderCalculator'),
        requestData,
    )
        .then(response => {
            dispatch(runCalculatorServiceSuccess(step, response));
            dispatch(validateStepTransferWithMoney(step, originFundId)); // We must validate again in order to move to step 2
        })
        .catch(response => {
            dispatch(runCalculatorServiceFailure(step, response));
        });
};

const runCalculatorServiceFromMoney = (step, history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const immAccounts = getState().accounts.get('byId');
    const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
    const accountAmount = step1.get('accountAmount');
    const contractNumber = step1.getIn(['selectedAccount', 'contractNumber']);
    const selectedAccount = immAccounts.find(
        account => account.get('newContractNumber') === contractNumber,
    );

    const interveners = step1.get('interveners');
    const portfolioOrderValidFundsData = buildPortfolioOrderValidFundsData(
        immCmWalletBuy.getIn(['portfolios', 0]),
    );
    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            portfolioCalculatorCostumerInfo: {
                portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                availableAmount: accountAmount.get('amount'),
                currency: CM_EUR_CURRENCY,
                subAssetClassIndIsin: immCmWalletBuy.getIn([
                    'simulation',
                    'type',
                ]),
                cviejo: {
                    numerodecontrato: selectedAccount.get('contractNumber'),
                    subgrupo: selectedAccount.get('product'),
                },
                cnuevo: {
                    numerodecontrato: selectedAccount.get('newContractNumber'),
                    producto: selectedAccount.get('newProduct'),
                },
                portfolioCalculatorIntervInfo: interveners.map(intervener => ({
                    desIntervencion: intervener.get('type'),
                    participantForm: intervener.get('interventionForm'),
                    participantClass: intervener.get('interventionType'),
                    participantId: {
                        participantNumber: intervener.get('personNumber'),
                        participantType: intervener.get('personType'),
                    },
                })),
            },
            portfolioCalculatorFundInfo: portfolioOrderValidFundsData,
        },
    };

    dispatch(runCalculatorServiceRequest(step));
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('portfolioOrderCalculator'),
        requestData,
    )
        .then(response => {
            dispatch(runCalculatorServiceSuccess(step, response));
            dispatch(validateUIStep(step)); // We must validate again in order to move to step 2
        })
        .catch(response => {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const runCalculatorService = (step, originFundId) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const totalAmount = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'amount',
    ]);
    const originFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundInfo',
    ]);
    const originFund = originFundInfo.get('infoFondosPosicionGlobal');
    const originFundInterveners = originFundInfo.get('listadoIntervinientes');
    const portfolioOrderValidFundsData = buildPortfolioOrderCalculatorFundsData(
        immCmWalletBuy.getIn(['portfolios', 0]),
    );
    const allFundsInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'infoFondosTodos',
    ]);

    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            originFundTransferCalculatorInfo: {
                fullContratoDigitoControlOri: originFund.get(
                    'fullContratoDigitoControl',
                ),
                fundContractOri: {
                    fundContractOriIdProduct: originFund.getIn([
                        'contrato',
                        'producto',
                    ]),
                    fundContractOriIdNumber: originFund.getIn([
                        'contrato',
                        'numeroContrato',
                    ]),
                },
                originFundAmount: originFund.getIn([
                    'importes',
                    'total',
                    'valor',
                    'importeEur',
                    'importe',
                ]),
                originFundAmountCurrency: originFund.getIn([
                    'importes',
                    'total',
                    'valor',
                    'importeEur',
                    'moneda',
                ]),
                originFundSharesAmount:
                    originFund.getIn([
                        'importes',
                        'total',
                        'participaciones',
                    ]) || 0,
                originFundIsin: originFund.getIn([
                    'instrumentInfo',
                    'instrumentId',
                ]),
                originFundSubtipo: originFund.get('subtipoProducto'),
                originFundAccountInfo: {
                    cviejo: {
                        subgrupo: originFund.getIn([
                            'cuentaAsociada',
                            'subgrupo',
                        ]),
                        numerodecontrato: originFund.getIn([
                            'cuentaAsociada',
                            'numeroContrato',
                        ]),
                    },
                    accountAvailableAmount: {
                        availableAmount: originFund.getIn([
                            'cuentaAsociada',
                            'saldo',
                            'importe',
                        ]),
                        availableAmountCurrency: originFund.getIn([
                            'cuentaAsociada',
                            'saldo',
                            'moneda',
                        ]),
                    },
                },

                originFundTransferIntervInfo: originFundInterveners
                    .get('intervinientes')
                    .map(intervener => ({
                        identifDocumento: {
                            tipodocumentoofic: intervener.getIn([
                                'identifDocumento',
                                'tipodocumentoofic',
                            ]),
                            codigodedocumento: intervener.getIn([
                                'identifDocumento',
                                'codigodedocumento',
                            ]),
                        },
                        nomInterviniente: intervener.get('nomInterviniente'),
                        tipoIntervencion: intervener.get('tipoIntervencion'),
                        ordenIntervencion: intervener.get('ordenIntervencion'),
                    })),
            },
            destinationFundTransferCalculatorInfo: {
                fundTransferCalculatorPortfolioInfo: {
                    portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                    subAssetClassIndIsin: immCmWalletBuy.getIn([
                        'simulation',
                        'type',
                    ]),
                    destinationPortfolioTotalAmount: {
                        portfolioTotalAmount: totalAmount,
                        portfolioTotalCurrency: CM_EUR_CURRENCY,
                    },
                },
                fundTransferPortfolioFundsInfo: portfolioOrderValidFundsData,
            },
            infoFondosTodos: allFundsInfo,
        },
    };

    dispatch(runCalculatorServiceRequest(step));
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('fundTransferPortfolioOrderCalculator'),
        requestData,
    )
        .then(response => {
            dispatch(runCalculatorServiceSuccess(step, response));
            dispatch(validateStepFromFunds(step, originFundId)); // We must validate again in order to move to step 2
        })
        .catch(response => {
            dispatch(runCalculatorServiceFailure(step, response));
        });
};

const transferLiquidityOrchestrator = (dispatch, getState, dataToken) => {
    const immCmWalletBuy = getState().cm;
    const intervenersData = buildIntervenersData(
        immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP, 'interveners']),
    );
    const originFundMatchedInPortfolio = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundMatchedInPortfolio',
    ]);
    const validatedOriginFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_SECOND_STEP,
        'originFund',
    ]);
    const destFundsTransferCalculatorOutputList = validatedOriginFundInfo.getIn(
        ['destFundsTransferCalculatorOutput', 'destFundTransferCalculatorList'],
    );
    const destFundsTransferCalculatorOutputListFilter = destFundsTransferCalculatorOutputList.filter(
        destFund =>
            !destFund
                .get('operationType')
                .startsWith(CM_OPERATION_TYPE_TRASPASS) &&
            destFund.getIn(['fundContractDest', 'fundContractDestIdNumber']) !==
                originFundMatchedInPortfolio,
    );
    const portfolioOrderValidFundsData = buildPortfolioOrderValidFundsDataFromTransferMoney(
        destFundsTransferCalculatorOutputListFilter,
    );
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const necessaryTargetScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'scoring',
    ]);
    const testResultScore = immBrokerConvenienceMiFIDTest.getIn([
        'mifidv2',
        'score',
    ]);
    const originFundInfo = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'originFundInfo',
    ]);
    const originFundInterveners = originFundInfo.get('listadoIntervinientes');
    const immProfile = getState().profile;
    const accountNumber = immCmWalletBuy.getIn([
        'steps',
        CM_WIZARD_FIRST_STEP,
        'accountNumber',
    ]);
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(accountNumber);
    const accountNumberCCC = immAccount.getIn(['ibanComplex', 'codbban']);
    const publicSiteUrl = getPublicSiteUrl();

    const requestData = {
        header: {
            'Accept-Language': getLanguage(),
        },
        query: {
            portfolioOrderValidationInput: {
                portfolioOrderValidCustumerInfo: {
                    portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                    subAssetClassIndIsin: immCmWalletBuy.getIn([
                        'simulation',
                        'type',
                    ]),
                    availableAmount: immCmWalletBuy.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'accountAmount',
                        'amount',
                    ]),
                    currency: CM_EUR_CURRENCY,
                    partenonAccountNumber: {
                        accountContractNumber: immCmWalletBuy.getIn([
                            'steps',
                            CM_WIZARD_FIRST_STEP,
                            'selectedAccount',
                            'contractNumber',
                        ]),
                        accountIdProduct: immCmWalletBuy.getIn([
                            'steps',
                            CM_WIZARD_FIRST_STEP,
                            'selectedAccount',
                            'productNumber',
                        ]),
                    },
                    portfolioOrderIntervInfo: intervenersData.toJS(),
                },
                portfolioOrderValidInfo: {
                    portfolioOrderValidFundInfo: portfolioOrderValidFundsData,
                },
            },
            portfolioTransferConfirmationInput: {
                dataToken,
                portfolioTransferCustomerInfo: {
                    dateOrder: moment().format('YYYY-MM-DD'),
                    portfolioMifidRequiredFields: {
                        agentId: CHANGE_AGENT_ID,
                        convenienceTest: immBrokerConvenienceMiFIDTest.getIn([
                            'mifidv2',
                            'getTestOperationCode',
                        ]), // 'Convenience Test Disclaimer ID',
                        convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(
                            ['mifidv2', 'isConvenient'],
                        ), // Indicates if the operation is convenient.
                        disclaimers: getDisclaimers(
                            immBrokerConvenienceMiFIDTest,
                        ),
                        evaluatetRegistry: immBrokerConvenienceMiFIDTest.get(
                            'started',
                        ), // Indicates if the operation has been evaluated. Motor Mifid
                        marketTargetRegistry:
                            testResultScore >= necessaryTargetScore, // Indicates if the test result is greater than the target market of the product that the issuer.
                        necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(
                            ['mifidv2', 'targetMarketKnowledgeAndExperience'],
                        ), // Note that must be overcomed in the Target Market.
                        testConvenienceResult: testResultScore, // Current note obtained by the payer in the convenience test.
                    },
                    fundTransferIntervInfo: originFundInterveners
                        .get('intervinientes')
                        .map(intervener => ({
                            tipoIntervencion: intervener.get(
                                'tipoIntervencion',
                            ),
                            ordenIntervencion: intervener.get(
                                'ordenIntervencion',
                            ),
                            identifDocumento: {
                                codigodedocumento: intervener.getIn([
                                    'identifDocumento',
                                    'codigodedocumento',
                                ]),
                                tipodocumentoofic: intervener.getIn([
                                    'identifDocumento',
                                    'tipodocumentoofic',
                                ]),
                            },
                            nomInterviniente: intervener.get(
                                'nomInterviniente',
                            ),
                        }))
                        .toJS(),
                    portfolioServiceGeneralData: {
                        channel: CONNECTION_CHANNEL_INTERNET, // Connection channel: internet or intranet
                        clientAlias: immProfile.get('alias'),
                        ccc: accountNumberCCC, // Associated Current Account. Sample: '00730100530562931170'
                        mifidWarningText: generateMiFIDDisclaimers(
                            immBrokerConvenienceMiFIDTest,
                        ),
                        email: PersonalDataHelper.getEmail(immProfile),
                    },
                },
                portfolioDestTransferInfo: {
                    currency: CM_EUR_CURRENCY,
                    investmentAmount: immCmWalletBuy.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'amount',
                    ]),
                    portfolioId: immCmWalletBuy.getIn(['simulation', 'id']),
                    subAssetClassIndIsin: immCmWalletBuy.getIn([
                        'simulation',
                        'type',
                    ]),
                    portfolioDestTransferFundInfo: immCmWalletBuy
                        .getIn([
                            'orderValidation',
                            'portfolioOrderValidTransferOk',
                        ])
                        .map(fund => ({
                            communServiceOrderData: {
                                conditionPrize: '', // Amount the customer wants to operate
                                orderCondition: '', // Conditions of the order. Options: To market, for the best and Limit (A mercado, Por lo mejor, Limitada)
                                orderType: BROKER_ORDER_TYPE_BUY, // Type or the order. Options: Buy or sell. In this case 'Compra'
                                productType: BROKER_PRODUCT_TYPE_FUNDS_ES, // Type of the product, Options: shares, warrants, funds or etfs. In this case 'Funds'
                                sharesNumber: '', // Number of shares
                                termValidity: '', // Period of validity of the order. Sample: '2017-09-21T00:00:00'
                            },
                            communServiceDocumDate: {
                                marketingReport: `${publicSiteUrl}/assets/static/pdf/fondos/memorias/${fund.getIn(
                                    [
                                        'destinationFundData',
                                        'subAssetClassIsin',
                                    ],
                                )}.pdf`, //URL Memoria de comercialización
                                costYield: fund.getIn([
                                    'destinationFundData',
                                    'costYield',
                                ]), //hire fund pdf name generated by validation
                            },
                            transferFundData: {
                                fechaValor: fund.get('fechaValor'),
                                operationType: fund.get('operationType'),
                                transferTypeTotalPartial: fund.get(
                                    'transferTypeTotalPartial',
                                ),
                                originFundData: {
                                    codigoIsinOrigen: fund.getIn([
                                        'originFundData',
                                        'isinOrigen',
                                    ]),
                                    subtipoContratoOrigen: fund.getIn([
                                        'originFundData',
                                        'subtipoContratoOrigen',
                                    ]),
                                    claveFondoContrOrigen: fund.getIn([
                                        'originFundData',
                                        'claveFondoContrOrigen',
                                    ]),
                                    tipodeproductoContratoOrigen: originFundInfo.getIn(
                                        [
                                            'infoFondosPosicionGlobal',
                                            'contrato',
                                            'producto',
                                        ],
                                    ),
                                    contratoOrigen: {
                                        producto: originFundInfo.getIn([
                                            'infoFondosPosicionGlobal',
                                            'contrato',
                                            'producto',
                                        ]),
                                        numerodecontrato: originFundInfo.getIn([
                                            'infoFondosPosicionGlobal',
                                            'contrato',
                                            'numeroContrato',
                                        ]),
                                    },
                                },
                                destinationFundData: parseDestinationFundData(
                                    fund.get('destinationFundData'),
                                ),
                            },
                            ctaAsociada: fund.get('ctaAsociada'),
                            importeDispMonedaFondo: fund.get(
                                'importeDispMonedaFondo',
                            ),
                            subgrupoCtaAsociada: fund.get(
                                'subgrupoCtaAsociada',
                            ),
                            saldoDia: fund.get('saldoDia'),
                            ultimoValorLiquidativo: parseFloat(
                                fund.get('ultimoValorLiquidativo'),
                            ),
                            icsaldod: parseFloat(fund.get('icsaldod')),
                            tipoTraspasoTotalParcial: fund.get(
                                'transferTypeTotalParcial',
                            ),
                            indAltaFondoDest: fund.getIn([
                                'destinationFundData',
                                'indAltaFondoDestino',
                            ]),
                            participacTraspaso: fund.getIn([
                                'destinationFundData',
                                'participacTraspaso',
                            ]),

                            campox: 'P',
                            cantidadPorRepartir: '0',
                            tipodeproductoCtaAsociada: fund.getIn([
                                'ctaAsociada',
                                'subgrupo',
                            ]),
                            tipoDocumento: 'P',
                            tipoUnidadTraspaso: 'P',

                            importeTraspaso: {
                                importe: fund.getIn([
                                    'destinationFundData',
                                    'subAssetClassFundAmount',
                                ]),
                                divisa: fund.getIn([
                                    'destinationFundData',
                                    'currency',
                                ]),
                            },
                            orderMifidRequiredFields: {
                                productPrice: '',
                                reduceRisk: 'true',
                            },
                        })),
                },
                portfolioOrderType: 'B',
            },
        },
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('transferLiquidityOrchestrator'),
        requestData,
    )
        .then(response => {
            recordLink(
                PROC_SIGNATURE_PATTERN,
                CM_PROC_SUCCESS,
                CM_PROC_TRANSFER_ORDER,
            );
            dispatch(runOrchestratorServiceSuccess(response));
        })
        .catch(response => {
            dispatch(runOrchestratorServiceFailure(response));
        });
};

const orchestratorOrderConfirmation = () => (dispatch, getState) => {
    recordLink(PROC_SIGNATURE_PATTERN, CM_PROC_INIT, CM_PROC_TRANSFER_ORDER);
    const callback = (dispatch, getState, dataToken) => {
        dispatch(runOrchestratorServiceRequest());
        dispatch(updateConsents(dataToken))
            .then(() =>
                transferLiquidityOrchestrator(dispatch, getState, dataToken),
            )
            .catch(() =>
                transferLiquidityOrchestrator(dispatch, getState, dataToken),
            );
    };

    const isAlreadyFetching = getState().investmentFunds.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(
                dispatch,
                getState,
                callback,
            );
        });
    }
};

const validateStep = (step, history) => (dispatch, getState) => {
    const transferFromFunds = true;
    if (getState().cm.get('buyType') === CM_BUY_TYPE_MONEY) {
        dispatch(validateUIStep(step));
        let valid;
        switch (step) {
            case WIZARD_FIRST_STEP:
                valid =
                    getState().cm.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'valid',
                    ]) && getState().cm.get('isMinFundAmountValid');
                if (valid) {
                    recordLink(CM_PROC_BUY_FUND, CM_PROC_MONEY);
                    dispatch(runCalculatorServiceFromMoney(step, history));
                }
                break;
            case WIZARD_SECOND_STEP:
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_SECOND_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(validateWithAPI(step, history));
                }
            case WIZARD_THIRD_STEP:
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_THIRD_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(portfolioOrderConfirmation(!transferFromFunds, history));
                }
                break;
        }
    } else if (
        getState().cm.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ])
    ) {
        const originFund = getState().cm.get('originFund');
        dispatch(validateStepTransferWithMoney(step, originFund));

        let valid;
        switch (step) {
            case WIZARD_FIRST_STEP:
                valid =
                    getState().cm.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'valid',
                    ]) && getState().cm.get('isMinFundAmountValid');
                if (valid) {
                    recordLink(CM_PROC_BUY_FUND, CM_PROC_MONEY_TRANSFER);
                    dispatch(
                        runCalculatorServiceFromTransferMoney(step, originFund),
                    );
                }
                break;
            case WIZARD_SECOND_STEP:
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_SECOND_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(validateWithApiFromFunds(step));
                }
            case WIZARD_THIRD_STEP:
                const portfolioOrderValidationOutputEmpty = getState().cm.getIn(
                    [
                        'steps',
                        CM_WIZARD_THIRD_STEP,
                        'portfolioOrderValidationOutputEmpty',
                    ],
                );
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_THIRD_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(portfolioOrderConfirmation(!transferFromFunds, history));
                }
                if (portfolioOrderValidationOutputEmpty) {
                    dispatch(submitEmptyValidationFromFundsWithMoney());
                }
                break;
        }
    } else {
        const originFund = getState().cm.get('originFund');
        dispatch(validateStepFromFunds(step, originFund));

        let valid;
        switch (step) {
            case WIZARD_FIRST_STEP:
                valid =
                    getState().cm.getIn([
                        'steps',
                        CM_WIZARD_FIRST_STEP,
                        'valid',
                    ]) && getState().cm.get('isMinFundAmountValid');
                if (valid) {
                    recordLink(CM_PROC_BUY_FUND, CM_PROC_TRANSFER);
                    dispatch(runCalculatorService(step, originFund));
                }
                break;
            case WIZARD_SECOND_STEP:
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_SECOND_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(validateWithApiFromFunds(step));
                }
            case WIZARD_THIRD_STEP:
                valid = getState().cm.getIn([
                    'steps',
                    CM_WIZARD_THIRD_STEP,
                    'valid',
                ]);
                if (valid) {
                    dispatch(portfolioOrderConfirmation(transferFromFunds, history));
                }
                break;
        }
    }
};

const getFundsMinAmounts = (history) => (dispatch, getState) => {
    const immCmWalletBuy = getState().cm;
    const isinList = buildPortfolioIsinsList(
        immCmWalletBuy.getIn(['portfolios', 0]),
    );

    const requestData = {
        query: {
            isinList: isinList.join(','),
        },
    };

    dispatch(getFundsMinAmountsInProgress());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerGetFundsMinAmounts'),
        requestData,
    )
        .then(response => dispatch(getFundsMinAmountsSuccess(response)))
        .catch(() => dispatch(dispatch(errorActions.show('', true, history))));
};

const setBuyType = data => ({
    type: actionTypes.CM_BUY_TYPE_CHANGED,
    payload: {
        data,
    },
});

const showMessageErrorForCheck = showErrorMessage => dispatch => {
    dispatch({
        type: actionTypes.CM_SHOW_MESSAGE_ERROR_CHECK,
        payload: showErrorMessage,
    });
};
const changeStatusCheck = value => dispatch => {
    dispatch({
        type: actionTypes.CM_CHANGE_CHECK,
        payload: value,
    });
};
const validateCheck = () => (dispatch, getState) => {
    const checked = getState().cm.getIn([
        'steps',
        CM_WIZARD_SECOND_STEP,
        'isDisclaimerChecked',
    ]);
    const listDocuments = getState().brokerLegalDocumentation.get('boxes');
    let missingDocumentForRead = false;
    listDocuments.forEach(value => {
        value.get('documents').forEach(document => {
            if (document.get('read') === false) {
                missingDocumentForRead = true;
            }
        });
    });

    dispatch(showMessageErrorForCheck(missingDocumentForRead));
    dispatch(changeStatusCheck(missingDocumentForRead ? false : !checked));
};

module.exports = {
    filterAccountChange,
    changeDisclaimerCheck,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    validateStep,
    portfolioOrderConfirmation,
    changeType,
    setOriginFund,
    restoreDefaultInterveners,
    setIntervenerName,
    setIntervenerType,
    changeSelectedAccount,
    setAccount,
    disableNextButton,
    enableNextButton,
    getPortfolioRiskCategorization,
    setAmount,
    setInitialAmount,
    getPortfolioInfo,
    getContractsAsOriginTransfer,
    getFundsMinAmounts,
    setBuyType,
    saveOriginFundInfo,
    orchestratorOrderConfirmation,
    setAccountChanged,
    confirmLeaveTransferMoneyToOtherPage,
    activatePreLeaveModal,
    deactivatePreLeaveModal,
    resetStep,
    getPortfolioList,
    onWalletChange,
    resetOriginFund,
    saveOriginFundMatchedInPortfolio,
    resetConsents,
    setAllDocumentsRead,
    removeIntervener,
    addIntervener,
    validateCheck,
};
